<script>
  export let value;

  const LINKS = [
    {
      code: 'web',
      link: 'https://',
      icon: 'fa-solid fa-earth-europe',
      label: value.web,
    },
    {
      code: 'wbscEurope',
      link: 'https://www.wbsceurope.org/en/members/profile/baseball/',
      icon: 'fa-solid fa-baseball-bat-ball',
      label: 'WBSC Europe',
    },
    {
      code: 'facebook',
      link: 'https://www.facebook.com/',
      icon: 'fa-brands fa-facebook',
      label: 'Facebook',
    },
    {
      code: 'instagram',
      link: 'https://www.instagram.com/',
      icon: 'fa-brands fa-instagram',
      label: 'Instagram',
    },
    {
      code: 'twitter',
      link: 'https://www.twitter.com/',
      icon: 'fa-brands fa-twitter',
      label: 'Twitter',
    },
    {
      code: 'youtube',
      link: 'https://www.youtube.com/',
      icon: 'fa-brands fa-youtube',
      label: 'YouTube',
    },
  ];
</script>

<div class='links'>
  {#each LINKS as link}
    {#if value[link.code]}
      <a href={link.link + value[link.code]} class='links-element'>
        <div class='links-element-icon'> <i class={link.icon}/> </div>

        <div class='links-element-label'> {link.label} </div>
      </a>
    {/if}
  {/each}
</div>

<style>
  .links {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .links-element {
    display: flex;
    align-items: center;
    gap: 10px;

    height: 20px;

    text-decoration: none;

    color: inherit;
  }

  .links-element-icon {
    display: flex;
    justify-content: center;

    width: 24px;
  }

  .links-element-label {
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .links-element:hover .links-element-label {
    text-decoration-color: var(--black);
  }

  :global(body.dark) .links-element:hover .links-element-label {
    text-decoration-color: var(--grey-3);
  }
</style>
